import { render, staticRenderFns } from "./PdfImage.vue?vue&type=template&id=5aeb3a30"
import script from "./PdfImage.vue?vue&type=script&lang=js"
export * from "./PdfImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports